module.exports = __webpack_public_path__ + "img/shuanghuangrou.bdf8ce23.jpg";